import { ChatMessage } from "@super-real/types";
import { create } from "zustand";
import { getChatMessageTimeoutInMs } from "../helpers/getChatMessageTimeout";

interface State {
  /**
   * key is `chatMessageId`, value is `isHidden`
   */
  isHiddenRecord: Record<string, boolean>;
  hasHiddenChatMessages: boolean;
  timeouts: NodeJS.Timeout[];
  hide: (chatMessages: ChatMessage[]) => void;
  setIsHiddenRecord: (nextIsHiddenRecord: Record<string, boolean>) => void;
  reset: () => void;
}

export const useChatMessageVisibility = create<State>((set, get) => ({
  hasHiddenChatMessages: false,
  isHiddenRecord: {},
  timeouts: [],
  hide: (chatMessages: ChatMessage[]) => {
    const nextIsHiddenRecord: Record<string, boolean> = {};

    chatMessages.forEach((chatMessage, index) => {
      nextIsHiddenRecord[chatMessage.id] = true;

      const timeout = setTimeout(() => {
        get().setIsHiddenRecord({
          ...get().isHiddenRecord,
          [chatMessage.id]: false,
        });
      }, getChatMessageTimeoutInMs(index));

      get().timeouts.push(timeout);
    });

    get().setIsHiddenRecord(nextIsHiddenRecord);
  },
  setIsHiddenRecord: (nextIsHiddenRecord: Record<string, boolean>) => {
    set({
      isHiddenRecord: nextIsHiddenRecord,
      hasHiddenChatMessages: Object.keys(nextIsHiddenRecord).reduce(
        (result, id) => result || nextIsHiddenRecord[id],
        false
      ),
    });
  },
  reset: () => {
    get().timeouts.forEach((timeout) => clearTimeout(timeout));
    set({ isHiddenRecord: {}, hasHiddenChatMessages: false, timeouts: [] });
  },
}));
